class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');
    this.setupEventListeners();
  }

  setupEventListeners() {
    let allSearchForms = [];
    this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
    this.input.addEventListener('focus', this.onInputFocus.bind(this));
    if (allSearchForms.length < 2) return;
    allSearchForms.forEach((form) => form.addEventListener('reset', this.onFormReset.bind(this)));
    this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
    }
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      /*
        When a vehicle has been selected via the year/make/model picker,
        a global bar (`.global-selected-vehicle`) is injected after the
        header. On collection and search pages this can cause the browser
        to scroll to the search input when it receives focus, which then
        hides the header and logo off the top of the viewport (as seen
        in the user’s screenshot). To prevent this, only scroll the
        search component into view when no vehicle bar is present. The
        presence of `.global-selected-vehicle` indicates that a vehicle
        has been selected and the bar has been injected.
      */
      const vehicleBar = document.querySelector('.global-selected-vehicle');
      if (!vehicleBar) {
        this.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
      }
    });
  }
}

customElements.define('main-search', MainSearch);
